<template>
  <div id="app" class="app">
    <AppHeader
        :currentLang="currentLang"
        :flagCn="flagCn"
        :flagEn="flagEn"
        :t="t"
        @change-lang="changeLang"
    />
    <el-container>
      <!-- 顶部导航 -->
      <router-view :currentLang="currentLang"
                   :t="t"/>


      <!-- 底部信息 -->

    </el-container>
    <AppFooter :t="t" :address="contactInfo[0].address" :phone="contactInfo[0].phone"/>
  </div>
</template>

<script>
import AppHeader from './components/AppHeader.vue';
import AppFooter from './components/AppFooter.vue';
import {getIndex, listContactInfo} from '@/utils/http'
export default {
  name: "App",
  components: {
    AppHeader,
    AppFooter
  },
  data() {
    return {
      contactInfo:null,
      currentLang: 'zh',
      flagCn: 'https://flagcdn.com/w40/cn.png',
      flagEn: 'https://flagcdn.com/w40/gb.png',
      params:{
        eType:0,
        type:0
      },
      translations: {
        zh: {
          home: '首页',
          product: '产品',
          support: '支持服务',
          about: '关于骇客神',
          slogan: '铭剑出鞘 极速制胜',
          videoBackground: '视频背景播放',
          learnMore: '了解详情',
          productDesc: '为速度注入灵魂 极速性能飙限',
          exploreProducts: '探索骇客神前沿产品',
          ddr4: 'DDR4 内存条',
          ddr5: 'DDR5 内存条',
          laptop: '笔记本内存条',
          rgb: 'RGB 内存条',
          footerProduct: '产品中心',
          footerNews: '新闻中心',
          newsCompany: '公司新闻',
          newsMedia: '媒体报道',
          footerSupport: '客户服务',
          supportService: '售后服务',
          faq: '常见问题',
          techSupport: '技术支持',
          footerAbout: '关于我们',
          companyIntro: '公司简介',
          honors: '荣誉资质',
          milestones: '大事记',
          culture: '企业文化',
          footerJoin: '加入我们',
          joinUs: '加入我们',
          recruit: '招聘信息',
          footerContact: '联系我们',
          search:'搜索',
          address:'地址',
          email:'邮箱',
          contactOnline: '在线咨询',
          contactSales: '专业销售服务',
          contactService: '售后服务',
          contactName: '联系人',
          contactPhone: '联系电话',
          contactAddress: '地址',
          header1: "我们一直致力于为员工",
          header2: "打造一个优秀的职业发展平台",
          content1: "在这个平台上，我们倡导\"付出必有回报\"的价值观，尊重每个员",
          content2: "工的独立自主性和个人想法，并尽力为每个员工的发展创造条件",
          content3: "和机会。我们通过系统的培训体系与各种资源来保障我们可以推",
          content4: "动员工不断成长，实现每个人的理想。",
          jobTitle: "商务部 - 商务顾问",
          collapse: "收起",
          expand: "展开",
          duties: "岗位职责",
          d1: "负责向公司提供的商机线索通过电话沟通、网络即时交流、拜访等方式给客户提供顾问式销售服务工作；",
          d2: "针对客户需求和行业特点制订项目解决方案；",
          d3: "参与项目前期咨询、完成方案撰写、现场演示、商务谈判等工作；",
          d4: "负责维护稳定的客户关系；",
          d5: "协调整客户与项目团队的工作，提升客户满意度；",
          requirements: "任职要求",
          r1: "熟练运用 Microsoft Office 办公软件；",
          r2: "有计算机专业背景或互联网、广告、策划相关工作经验优先；",
          r3: "主动、自信、学习能力强；",
          r4: "拥有积极、乐观的心态，有耐心，具较强的服务意识，有一定的沟通谈判能力及良好人际交往能力，具有良好的团队合作精神；",
          r5: "能够在高压力下，交付工作高标准高质量完成交办的工作任务；",
          description: "4G DDR4 2400 288Pin 512MBX8 Registered VLP 1.2V -40~85℃ Samsung芯片",
          feature1: "DDR4-2400 Registered DIMM",
          feature2: "超低剖面设计",
          feature3: "宽温支持",
          feature4: "30μ 镀金厚度",
          feature5: "1.2V 低功耗",
          feature6: "更高的可靠性与可维护性 (RAS)",
          getQuote: "取得报价",
          resourceLink: "技术资源链接",
          catalog: "产品型录",
          productTab: '产品',
          onlineTab: '线上资源',
          contactUs: '联系我们',
          showFilters: '显示筛选器',
          hideFilters: '隐藏筛选器',
          reset: '重置',
          memory: 'Memory',
          productTitle: '产品',
          itemsCount: '个项目',
          contactClicked: '点击了联系我们',
          Capacity: '容量',
          contactSh:'售后咨询',
          contactNameSh:'售后联系人',
          contactPhoneSh:'售后电话',
          contactAddressSh:'售后地址',
          contactXs:'销售咨询',
          contactNameXs:'销售联系人',
          contactPhoneXs:'销售电话',
          contactAddressXs:'销售地址',
          'Chip Manufacturer': '芯片厂商',
          'Chip Organization': '芯片架构',
          Feature: '特性',
          Manufacturer: '制造商',
          'Operating Temperature': '工作温度',
          productText:'PC5-8000-CAMM2',
          productText1:'为速度注入灵魂 点亮性能极限',
          title: '国惠科技内存条质保政策说明',
          title1: '感谢您选用国惠科技内存条产品。为保障您的权益，我们为正品内存条提供标准化质保服务，并支持通过 RMA 编码在线查询售后处理进度',
          title2: '',
          step1: '1.售后服务码与邮箱接收验证码，获得 RMA 编码',
          step2: '2.根据指引回寄产品，并附上 RMA 编码与购机凭证',
          step3: '3.工程师检测后确认质保状态，进行处理',
          step4: '4.可通过下方查询入口查看处理进度',
          step5: '5.工程师检测后确认质保状态，进行处理',
          email1: '官方客服邮箱',
          workingHours: '工作时间',
          time: '工作日 9:00-18:00',
          emailInput: '您的邮箱',
          codeInput: '验证码',
          sendCode: '发送验证码',
          agree: '我已阅读 用户手册和隐私政策',
          rmaInput: 'RMA码',
          pleaseInputEmail: '请输入邮箱地址',
          pleaseAgree: '请先同意用户协议',
          codeSent: '验证码已发送',
          searchRwa:'查询'
        },
        en: {
          home: 'Home',
          product: 'Products',
          support: 'Support',
          about: 'About HIGX',
          slogan: 'Unleash the Sword, Win at Speed',
          videoBackground: 'Video Background',
          learnMore: 'Learn More',
          productDesc: 'Inject soul into speed, unleash extreme performance',
          exploreProducts: 'Explore HIGX Cutting-edge Products',
          ddr4: 'DDR4 Memory',
          ddr5: 'DDR5 Memory',
          laptop: 'Laptop Memory',
          rgb: 'RGB Memory',
          footerProduct: 'Product Center',
          footerNews: 'News Center',
          newsCompany: 'Company News',
          newsMedia: 'Media Reports',
          footerSupport: 'Customer Service',
          supportService: 'After-sale Service',
          faq: 'FAQ',
          techSupport: 'Tech Support',
          footerAbout: 'About Us',
          companyIntro: 'Company Profile',
          honors: 'Honors',
          milestones: 'Milestones',
          culture: 'Culture',
          footerJoin: 'Join Us',
          joinUs: 'Join Us',
          recruit: 'Recruitment',
          footerContact: 'Contact Us',
          search:'Search',
          address:'Address',
          email:'Email',
          contactOnline: 'Online Consultation',

          contactSales: 'Professional Sales Service',
          contactService: 'After-sales Service',
          contactName: 'Contact Person',
          contactPhone: 'Phone Number',
          contactAddress: 'Address',
          header1: "We are committed to providing employees",
          header2: "with an excellent career development platform",
          content1: 'On this platform, we advocate the value of "hard work pays off" and respect every',
          content2: "employee's independence and ideas, striving to create conditions",
          content3: "and opportunities for each employee's development. Through systematic training and resources,",
          content4: "we help employees grow and realize their dreams.",
          jobTitle: "Business Dept - Consultant",
          collapse: "Collapse",
          expand: "Expand",
          duties: "Job Responsibilities",
          d1: "Provide consultative sales services to clients through phone, chat, or visit based on company-provided leads;",
          d2: "Develop project solutions according to client needs and industry characteristics;",
          d3: "Participate in early-stage consulting, proposal writing, presentations, and negotiations;",
          d4: "Maintain stable client relationships;",
          d5: "Coordinate between clients and project team to improve satisfaction;",
          requirements: "Job Requirements",
          r1: "Proficient in Microsoft Office software;",
          r2: "Background in computer science or experience in internet, advertising, or planning preferred;",
          r3: "Proactive, confident, and eager to learn;",
          r4: "Positive attitude, patient, strong service mindset, good communication and team spirit;",
          r5: "Able to perform under pressure and deliver high-quality work;",
          description: "4G DDR4 2400 288Pin 512MBX8 Registered VLP 1.2V -40~85℃ Samsung Chip",
          feature1: "DDR4-2400 Registered DIMM",
          feature2: "Very Low Profile",
          feature3: "Wide temperature",
          feature4: "30μ gold plating thickness",
          feature5: "1.2V Power Consumption",
          feature6: "Better reliability and serviceability (RAS)",
          getQuote: "Get a Quote",
          resourceLink: "Technical Resource Link",
          catalog: "Product Catalog",
          productTab: 'Products',
          onlineTab: 'Online Resources',
          contactUs: 'Contact Us',
          showFilters: 'Show Filters',
          hideFilters: 'Hide Filters',
          reset: 'Reset',
          memory: 'Memory',
          productTitle: 'Products',
          itemsCount: ' items',
          contactClicked: 'Contact us clicked',
          Capacity: 'Capacity',
          contactSh: 'After Sales Consultation',
          contactNameSh:'After sales contact person',
          contactPhoneSh:'After sales phone number',
          contactAddressSh:'After sales address',
          contactXs:'Sales Consultation',
          contactNameXs:'Sales contact person',
          contactPhoneXs:'Sales Tel',
          contactAddressXs:'Sales address',
          'Chip Manufacturer': 'Chip Manufacturer',
          'Chip Organization': 'Chip Organization',
          Feature: 'Feature',
          Manufacturer: 'Manufacturer',
          'Operating Temperature': 'Operating Temperature',
          productText:'PC5-8000-CAMM2',
          productText1:'Inject soul into speed and ignite performance limits',
          title: 'GUOHUI Memory Warranty Policy',
          title1: 'Thank you for choosing Guohui Technology\'s memory module products. To protect your rights, we provide standardized warranty services for genuine memory modules Service and support online inquiry of after-sales processing progress through RMA code',
          title2: 'Service and support online inquiry of after-sales processing progress through RMA code',
          step1: '1. Use your service code and email to receive RMA code',
          step2: '2. Return the product with RMA code and purchase proof',
          step3: '3. Our engineer will verify and process the item',
          step4: '4. You can check status via tracking portal',
          step5: '5. Engineer confirms and processes accordingly',
          email1: 'Official Support Email',
          workingHours: 'Working Hours',
          time: 'Mon-Fri 9:00-18:00',
          emailInput: 'Your Email',
          codeInput: 'Verification Code',
          sendCode: 'Send Code',
          agree: 'I have read the User Manual and Privacy Policy',
          rmaInput: 'RMA Code',
          pleaseInputEmail: 'Please input your email',
          pleaseAgree: 'Please agree to the terms first',
          codeSent: 'Verification code sent',
          searchRwa:'Search'
        }
      }
    };
  },
  created() {
    this.initContactInfo();
  },
  methods: {
    t(key) {
      console.log(this.currentLang)
      return this.translations[this.currentLang][key] || key;
    },
    changeLang(lang) {
      if (lang !== this.currentLang) {
        this.currentLang = lang;
      }
      if(this.currentLang==='zh'){
        this.params.eType=0;
      }else{
        this.params.eType=1;
      }
    },
    initContactInfo(){
      console.log(this.params)
      listContactInfo(this.params).then(response => {
        this.contactInfo=response.rows;
        console.log(this.contactInfo[0].address)
      })
    }
  }
};
</script>

<style scoped>
.el-menu--horizontal > .el-menu-item.is-active {
  border-bottom: none !important;
}
.el-menu--horizontal > .el-menu-item:hover {
  border-bottom: none !important;
}
.app {
  background: #0d0d0d;
  color: #fffFFF;
}

.hero {
  position: relative;
  width: 100%;
  height: 300px; /* 固定高度 */
  overflow: hidden;
  margin-top:150px;
}

.video-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover; /* 让视频铺满容器，超出的部分裁掉 */
}


.hero-text {
  position: absolute;
  top: 30%;
  left: 50%;
  transform: translate(-50%, -30%);
  transition: all 0.3s ease;
  text-align: center;
}

.featured-product {
  text-align: center;
  padding: 40px 20px;
}

.featured-img {
  width: 100%;
  height: auto;
}

.product-list {
  text-align: center;
  background-color: #262A30;
  padding-bottom: 30px;
  padding-top: 10px;
}

.product-image {
  width: 100%;
}


</style>
